<script setup>
import {Filter} from "lucide-vue-next";
import {computed} from "vue";

const props = defineProps({
    currentView: {
        type: String,
    },
    currentSort: {
        type: String,
    },
    isUserLoggedIn: {
        type: Boolean,
    },
    userSponsoredCount: {
        type: Number,
    },
    releasedCount: {
        type: Number,
    },
    totalCount: {
        type: Number,
    },
    sponsoredCount: {
        type: Number,
        default: 0,
    },
    sortOptions: {
        type: Object
    }
})

defineEmits(['updateCurrentView', 'updateCurrentSort'])

const viewLabel = computed(() => {
    if (props.currentView === 'mine') return 'sponsored'
    if (props.currentView === 'released') return 'released'
    if (props.currentView === 'sponsored') return 'sponsored'
    return 'active'
})

const filteredCount = computed(() => {
    if (props.currentView === 'mine') {
        return props.userSponsoredCount;
    }
    if (props.currentView === 'released') {
        return props.releasedCount;
    }
    if (props.currentView === 'sponsored') {
        return props.sponsoredCount;
    }
    return props.totalCount
})
</script>

<template>
    <div class="hidden lg:block sticky top-[63px] z-40 bg-zinc-900/95 backdrop-blur-xl border-b border-zinc-800">
        <div class="max-w-[1400px] mx-auto px-6 py-4">
            <div class="flex items-center justify-between gap-6">
                <div class="flex items-center gap-4 min-w-0">
                    <div class="inline-flex rounded-2xl bg-white/[0.06] border border-white/10 p-1">
                        <button
                            @click="$emit('updateCurrentView','all')"
                            :class="[
                                'h-10 px-4 rounded-xl text-sm font-semibold transition',
                                currentView === 'all'
                                    ? 'bg-white/10 text-white shadow-sm'
                                    : 'text-white/60 hover:text-white hover:bg-white/[0.06]'
                            ]"
                        >
                            All
                        </button>

                        <button
                            @click="$emit('updateCurrentView', 'sponsored')"
                            :class="[
                                'h-10 px-4 rounded-xl text-sm font-semibold transition flex items-center gap-2',
                                currentView === 'sponsored'
                                    ? 'bg-white/10 text-white shadow-sm'
                                    : 'text-white/60 hover:text-white hover:bg-white/[0.06]'
                            ]"
                        >
                            Sponsored
                            <span v-if="sponsoredCount > 0" class="min-w-[1.25rem] h-5 px-2 rounded-full bg-blue-600 text-white text-xs font-bold flex items-center justify-center">
                                {{ sponsoredCount }}
                            </span>
                        </button>

                        <button
                            @click="$emit('updateCurrentView', 'released')"
                            :class="[
                                'h-10 px-4 rounded-xl text-sm font-semibold transition flex items-center gap-2',
                                currentView === 'released'
                                    ? 'bg-white/10 text-white shadow-sm'
                                    : 'text-white/60 hover:text-white hover:bg-white/[0.06]'
                            ]"
                        >
                            Released
                            <span v-if="releasedCount > 0" class="min-w-[1.25rem] h-5 px-2 rounded-full bg-emerald-600 text-white text-xs font-bold flex items-center justify-center">
                                {{ releasedCount }}
                            </span>
                        </button>

                        <button
                            v-if="isUserLoggedIn"
                            @click="$emit('updateCurrentView','mine')"
                            :class="[
                                'h-10 px-4 rounded-xl text-sm font-semibold transition flex items-center gap-2',
                                currentView === 'mine'
                                    ? 'bg-white/10 text-white shadow-sm'
                                    : 'text-white/60 hover:text-white hover:bg-white/[0.06]'
                            ]"
                        >
                            Mine
                            <span v-if="userSponsoredCount > 0" class="min-w-[1.25rem] h-5 px-2 rounded-full bg-red-600 text-white text-xs font-bold flex items-center justify-center">
                                {{ userSponsoredCount }}
                            </span>
                        </button>
                    </div>

                    <span class="text-sm text-white/35 truncate">
                        {{ filteredCount }}
                        {{ viewLabel }}
                      </span>
                </div>

                <div v-if="currentView === 'all'" class="flex items-center gap-3 shrink-0">
                    <Filter class="w-4 h-4 text-white/35" />
                    <span class="text-sm text-white/35">Sort</span>
                    <select
                        :value="currentSort"
                        @change="$emit('updateCurrentSort', $event.target.value)"
                        class="h-10 bg-white/[0.06] border border-white/10 focus:border-none text-white text-sm font-semibold rounded-xl px-3 hover:bg-white/[0.08] focus:outline-none focus:ring-2 focus:ring-red-500/60 cursor-pointer transition"
                    >
                        <option v-for="(label, value) in sortOptions" :value="value" :key="value">{{ label }}</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
